<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav">
        <li class="nav-item">
          <a href="https://www.tillered.com"
            target="_blank"
            rel="noopener"
            class="nav-link" >
            tillered.com
          </a>
        </li>
        <li class="nav-item">
          <a href="https://www.tillered.com/faq"
            target="_blank"
            rel="noopener"
            class="nav-link">
            FAQ
          </a>
        </li>
      </ul>
      <div class="copyright">
        &copy; {{ year }}
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
